/**
 * @file useMembers.js
 * @location src/store/useMembers.js
 * @role S.members 에 바인딩된 멤버 헬퍼 묶음
 *
 * 사용 예:
 *   const { members, mname, mrole, isManagerById } = useMembers();
 *   <span>{mname(t.aee)}</span>
 *
 * memberUtils.js 의 순수 함수 (id, members) → 본 훅에서 members 자동 주입.
 * 컴포넌트 측에서 매번 S.members 를 인자로 넘기는 번거로움 제거 목적.
 */
import { useApp } from './AppContext';
import {
  mname     as mnameFn,
  mrole     as mroleFn,
  isManagerById as isManagerByIdFn,
} from '../utils/memberUtils';

export function useMembers() {
  const { S } = useApp();
  const members = S.members;
  return {
    members,
    mname:     (id) => mnameFn(id, members),
    mrole:     (id) => mroleFn(id, members),
    isManagerById: (id) => isManagerByIdFn(id, members),
  };
}
